import './App.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import Header from './Layout/User/Header';
import Home from './Pages/User/Home';
import Parking from './Pages/User/Parking';
import SecurityParking from './Pages/Security/Parking';
import History from './Pages/Security/History';
import AdminParking from './Pages/Admin/Parking';
import AdminHistory from './Pages/Admin/History';
import AdminUsers from './Pages/Admin/Users';
import AdminLots from './Pages/Admin/Lots';
import Login from './Pages/Authentication/Login/Login';
import ForgotPassword from './Pages/Authentication/Forgot/Forgot';
function App() {
  useEffect(() => {
    const userAgent = navigator.userAgent;
    const rootElement = document.getElementById('root');

    if (userAgent.includes('Firefox')) {
      rootElement?.classList.add('firefox');
    } else if (userAgent.includes('Chrome') && !userAgent.includes('Edge')) {
      rootElement?.classList.add('chrome');
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      rootElement?.classList.add('safari');
    }
  }, []);
  return (
    <React.Fragment>
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path='/home' element={<Home />} />
      <Route path='/login' element={<Login />} />
      <Route path='/forgot' element={<ForgotPassword />} />
      <Route path='/parking' element={<Parking />} />
      <Route path='/security/parking' element={<SecurityParking />} />
      <Route path='/security/history' element={<History />} />
      <Route path='/admin/parking' element={<AdminParking />} />
      <Route path='/admin/history' element={<AdminHistory />} />
      <Route path='/admin/users' element={<AdminUsers />} />
      <Route path='/admin/lots' element={<AdminLots />} />
    </Routes>
    </React.Fragment>
 
  );
}

export default App;
